import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import debounce from "lodash/debounce";
import {
  changeFilter,
  changeProductsList,
  sortProductsList,
  changeProductsSortBy,
  changeProductsSortOrder,
  clearFilter
} from "../../store/product";
import {
  getFilter,
  toggleModal,
  getModalStatus,
  getSortByStatus,
  getSortOrderStatus,
  getLobingState,
  isUserLoggedIn,
  resetOffset,
  showHots
} from "../../store/common";
import { getTranslate, getActiveLanguage } from "react-localize-redux";
import Select from "react-select";
import removeAccents from 'remove-accents';

const ProductsFilter = ({
  changeFilter,
  changeProductsList,
  getCodeFilter,
  getNameFilter,
  getPriceFilter,
  getCompatibilityFilter,
  getColorFilter,
  getEditionFilter,
  getManufacturerFilter,
  getEANFilter,
  getQuantityFilter,
  getColorTagFilter,
  getSortBy,
  getSortOrder,
  changeProductsSortBy,
  changeSortOrder,
  sortProductsList,
  manufacturerList,
  editonList,
  compatibilityList,
  colorList,
  flexColorList,
  translate,
  clearFilter,
  currentLanguage,
  isHotsShowing,
  showHotProducts,
  isAnyHotProducts,
  isLoading,
  dailyHotProducts, getSaleFilter
}) => {

  const filterOptions = (
    candidate,
    input
  ) => {
    if (input) {
      const term = removeAccents(input).trim().toString().toLowerCase();
      const candidateString = candidate ? removeAccents(candidate.value.trim().toString().toLowerCase()) : '';
      const inputArr = term.split(" ");
      if (inputArr.length > 1) {
        return inputArr.every(i => {
          return candidateString.includes(i);
        });
      }
      return candidateString.includes(term);

    }
    return true;
  };

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div className={`filterSetup ${isHotsShowing && "invert"}`}>
          <h5 className="filterSetup__heading">
            {translate(
              "molecules.containers.productsFilter.search_in_products"
            )}
          </h5>

          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="code">
                  {translate("molecules.containers.productsFilter.code")}
                </label>
                <input
                  id="productName"
                  type="text"
                  // value={lobingState}
                  onChange={e => {
                    changeFilter(e.target.value, "code");
                    changeProductsList(e.target.value, "code", currentLanguage);
                    if (!e.target.value) {
                      clearFilter('code');
                    }
                    e.stopPropagation();
                  }}
                  className="form-control"
                  placeholder={translate(
                    "molecules.containers.productsFilter.code"
                  )}
                  aria-label={translate(
                    "molecules.containers.productsFilter.code"
                  )}
                  aria-describedby="basic-addon2"
                />
                {getCodeFilter && getCodeFilter.length > 0 && (
                  <span
                    className="clearInput"
                    onClick={() => clearFilter("code")}
                  >
                    {/* <i className="fa fa-times" /> */}
                  </span>
                )}
              </div>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="flex_name">
                  {translate("molecules.containers.productsFilter.flex_name")}
                </label>
                <input
                  minLength={2}
                  // value={getNameFilter}
                  onChange={e => {
                    changeFilter(e.target.value, "flex_name");
                    changeProductsList(
                      e.target.value,
                      "flex_name",
                      currentLanguage
                    );
                    if (!e.target.value) {
                      clearFilter("flex_name")
                    }
                    e.stopPropagation();
                  }}
                  className="form-control"
                  placeholder={translate(
                    "molecules.containers.productsFilter.flex_name"
                  )}
                />
                {getNameFilter && getNameFilter.length > 0 && (
                  <span
                    className="clearInput"
                    onClick={() => clearFilter("flex_name")}
                  >
                    {/* <i className="fa fa-times" /> */}
                  </span>
                )}
              </div>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="edition">
                  {translate(
                    "molecules.containers.productsFilter.compatibility"
                  )}
                </label>
                <Select
                  placeholder={translate(
                    "molecules.containers.productsFilter.search"
                  )}
                  className="multi-select"
                  isMulti
                  options={compatibilityList}
                  onChange={e => {
                    changeFilter(e, "compatibility");
                    changeProductsList(
                      e.length > 0 && e[0].value,
                      "compatibility"
                    );

                    if (e.length === 0) {
                      clearFilter("compatibility")
                    }
                  }}
                  filterOption={filterOptions}
                />
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="price">
                  {translate("molecules.containers.productsFilter.price")}
                </label>
                <input
                  minLength={2}
                  // value={getPriceFilter}
                  onChange={e => {
                    changeFilter(e.target.value, "price");
                    changeProductsList(e.target.value, "price");

                    if (!e.target.value) {
                      clearFilter("price")
                    }
                    e.stopPropagation();
                  }}
                  className="form-control"
                  placeholder={translate(
                    "molecules.containers.productsFilter.price"
                  )}
                />
                {getPriceFilter && getPriceFilter.length > 0 && (
                  <span
                    className="clearInput"
                    onClick={() => clearFilter("price")}
                  >
                    {/* <i className="fa fa-times" /> */}
                  </span>
                )}
              </div>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="color">
                  {translate("molecules.containers.productsFilter.color")}
                </label>

                <Select
                  placeholder={translate(
                    "molecules.containers.productsFilter.search"
                  )}
                  className="multi-select"
                  isMulti
                  options={colorList}
                  onChange={e => {
                    changeFilter(e, "color");
                    changeProductsList(e.length > 0 && e[0].value, "color");

                    if (e.length === 0) {
                      clearFilter("color")
                    }
                  }}

                />
              </div>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="edition">
                  {translate("molecules.containers.productsFilter.edition")}
                </label>

                <Select
                  placeholder={translate(
                    "molecules.containers.productsFilter.search"
                  )}
                  className="multi-select"
                  isMulti
                  options={editonList}
                  onChange={e => {
                    changeFilter(e, "edition");
                    changeProductsList(e.length > 0 && e[0].value, "edition");

                    if (e.length === 0) {
                      clearFilter("edition")
                    }
                  }}

                />
              </div>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="manufacturer">
                  {translate(
                    "molecules.containers.productsFilter.manufacturer"
                  )}
                </label>
                <Select
                  placeholder={translate(
                    "molecules.containers.productsFilter.search"
                  )}
                  className="multi-select"
                  isMulti
                  options={manufacturerList}
                  onChange={e => {

                    changeFilter(e, "manufacturer");
                    changeProductsList(
                      e.length > 0 && e[0].value,
                      "manufacturer"
                    );

                    if (e.length === 0) {
                      clearFilter("manufacturer")
                    }
                  }}

                />
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="EAN">
                  {translate("molecules.containers.productsFilter.ean")}
                </label>
                <input
                  minLength={2}
                  // value={getEANFilter}
                  onChange={e => {
                    changeFilter(e.target.value, "ean");
                    changeProductsList(e.target.value, "ean");

                    if (!e.target.value) {
                      clearFilter("ean")
                    }
                    e.stopPropagation();
                  }}
                  className="form-control"
                  placeholder={translate(
                    "molecules.containers.productsFilter.ean"
                  )}
                />
                {getEANFilter && getEANFilter.length > 0 && (
                  <span
                    className="clearInput"
                    onClick={() => clearFilter("ean")}
                  >
                    {/* <i className="fa fa-times" /> */}
                  </span>
                )}
              </div>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="quantity">
                  {translate("molecules.containers.productsFilter.quantity")}
                </label>

                <input
                  minLength={2}
                  // value={getQuantityFilter}
                  onChange={e => {
                    changeFilter(e.target.value, "stock");
                    changeProductsList(e.target.value, "stock");

                    if (!e.target.value) {
                      clearFilter("stock")
                    }
                    e.stopPropagation();
                  }}
                  className="form-control"
                  placeholder={translate(
                    "molecules.containers.productsFilter.quantity"
                  )}
                />
                {getQuantityFilter && getQuantityFilter.length > 0 && (
                  <span
                    className="clearInput"
                    onClick={() => clearFilter("stock")}
                  >
                    {/* <i className="fa fa-times" /> */}
                  </span>
                )}
              </div>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="quantity">
                  {translate("molecules.containers.productsFilter.color_tag")}
                </label>
                <Select
                  placeholder={translate(
                    "molecules.containers.productsFilter.search"
                  )}
                  className="multi-select"
                  isMulti
                  options={flexColorList}
                  onChange={e => {
                    changeFilter(e, "flex_color");
                    changeProductsList(
                      e.length > 0 && e[0].value,
                      "flex_color"
                    );

                    if (e.length === 0) {
                      clearFilter("flex_color")
                    }
                  }}

                  filterOption={filterOptions}
                />
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="sortBy">
                  {translate("molecules.containers.productsFilter.sortBy")}
                </label>

                <div className="orderGroup">
                  <div className="orderGroup__half">
                    <select
                      name="sortBy"
                      id="sortBy"
                      onChange={e => {
                        changeProductsSortBy(e.target.value);
                        sortProductsList(e.target.value, getSortOrder);
                      }}
                    >
                      <option value="marza" selected={getSortBy === "marza"}>
                        {translate("molecules.containers.productsFilter.marza")}
                      </option>
                      <option value="code" selected={getSortBy === "code"}>
                        {translate("molecules.containers.productsFilter.code")}
                      </option>
                      <option value="price" selected={getSortBy === "price"}>
                        {translate("molecules.containers.productsFilter.price")}
                      </option>
                      <option value="date" selected={getSortBy === "date"}>
                        {translate("molecules.containers.productsFilter.date")}
                      </option>
                    </select>
                  </div>
                  <div className="orderGroup__half">
                    <button
                      type="button"
                      className={
                        "button-filter asc  " +
                        (getSortOrder === "asc" ? "active" : null)
                      }
                      onClick={() => {
                        changeSortOrder("asc");
                        sortProductsList(getSortBy, "asc");
                      }}
                    >
                      {/* <i className="fa fa-sort-amount-asc"></i> */}
                    </button>
                    <button
                      type="button"
                      className={
                        "button-filter desc  " +
                        (getSortOrder === "desc" ? "active" : null)
                      }
                      onClick={() => {
                        changeSortOrder("desc");
                        sortProductsList(getSortBy, "desc");
                      }}
                    >
                      {/* <i className="fa fa-sort-amount-desc"></i> */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="quantity">
                  {translate("molecules.containers.productsFilter.sales")} {isAnyHotProducts && ' / ' + translate("molecules.containers.productsFilter.hots")}
                </label>
                <div className="orderGroup">
                  <div className="orderGroup__half">
                    <div>
                      <input type="checkbox" id="sales" name="sales" checked={getSaleFilter} onClick={(e) => {
                        if (getSaleFilter) {
                          clearFilter("sale")
                        } else {
                          changeFilter(e.target.value === 'on', "sale");
                          changeProductsList(e.target.value === 'on', "sale");
                        }
                      }} />{" "}
                      <label for="sales">{translate("molecules.containers.productsFilter.sales")}</label>
                    </div>
                  </div>
                  <div className="orderGroup__half">
                    {isAnyHotProducts && (
                      <button
                        type="button"
                        disabled={isLoading}
                        className={`btn btn-${isHotsShowing ? "light" : "danger"
                          }`}
                        onClick={() => !isLoading && showHotProducts()}
                      >
                        {translate("molecules.containers.productsFilter.hotsLabel")}
                        {"  "}
                        {dailyHotProducts > 0 && (
                          <span className="badge badge-light">
                            {dailyHotProducts}
                          </span>
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProductsFilter.propTypes = {
  changeFilter: PropTypes.func,
  changeProductsList: PropTypes.func,
  getCodeFilter: PropTypes.string,
  getNameFilter: PropTypes.string,
  getPriceFilter: PropTypes.string,
  getCompatibilityFilter: PropTypes.string,
  getColorFilter: PropTypes.string,
  getEditionFilter: PropTypes.string,
  getManufacturerFilter: PropTypes.string,
  getEANFilter: PropTypes.string,
  getQuantityFilter: PropTypes.string,
  getColorTagFilter: PropTypes.string,
  getSortBy: PropTypes.string,
  getSortOrder: PropTypes.string,
  changeProductsSortBy: PropTypes.func,
  changeSortOrder: PropTypes.func,
  sortProductsList: PropTypes.func,
  manufacturerList: PropTypes.array,
  editonList: PropTypes.array,
  compatibilityList: PropTypes.array,
  flexColorList: PropTypes.array,
  colorList: PropTypes.array,
  translate: PropTypes.func,
  clearFilter: PropTypes.func,
  isHotsShowing: PropTypes.bool,
  isAnyHotProducts: PropTypes.bool,
  isLoading: PropTypes.bool,
  getSaleFilter: PropTypes.bool,
  dailyHotProducts: PropTypes.number
};

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).id,
  getCodeFilter: getFilter(state.product.filter, "code"),
  getNameFilter: getFilter(state.product.filter, "flex_name"),
  getPriceFilter: getFilter(state.product.filter, "price"),
  getCompatibilityFilter: getFilter(state.product.filter, "compatibility"),
  getColorFilter: getFilter(state.product.filter, "color"),
  getEditionFilter: getFilter(state.product.filter, "edition"),
  getManufacturerFilter: getFilter(state.product.filter, "manufacturer"),
  getEANFilter: getFilter(state.product.filter, "ean"),
  getQuantityFilter: getFilter(state.product.filter, "stock"),
  getColorTagFilter: getFilter(state.product.filter, "color_tag"),
  getSaleFilter: getFilter(state.product.filter, "sale"),
  getFilterSortDropdownStatus: getModalStatus(
    state.common.modals ? state.common.modals.filter_products_sort : null
  ),
  getSortBy: getSortByStatus(state.product.sortBy),
  getSortOrder: getSortOrderStatus(state.product.sortOrder),
  lobingState: getLobingState(state.common.lobing),
  isUserLoggedIn: isUserLoggedIn(state.common.token),
  manufacturerList: state.common.manufacturer,
  editonList: state.common.edition,
  compatibilityList: state.common.compatibility,
  flexColorList: state.common.flexColors,
  colorList: state.common.color[getActiveLanguage(state.locale).code],
  isHotsShowing: state.common.showingHotsProducts,
  isAnyHotProducts: state.common.isAnyHotProducts,
  isLoading: state.product.loading,
  dailyHotProducts: state.common.dailyHotProducts
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  changeFilter: (val, type) => {
    dispatch(changeFilter(val, type));
  },
  changeProductsList: debounce((val, type, langId = 1) => {
    // console.log("type:" + type + " - value:" + val);
    dispatch(changeProductsList(val, type, langId));
    dispatch(resetOffset());
  }, 500),
  toggleModal: (modalName, action) => dispatch(toggleModal(modalName, !action)),
  changeProductsSortBy: sortBy => dispatch(changeProductsSortBy(sortBy)),
  changeSortOrder: sortOrder => dispatch(changeProductsSortOrder(sortOrder)),
  sortProductsList: (sortBy, sortOrder) =>
    dispatch(sortProductsList(sortBy, sortOrder)),
  clearFilter: type => {
    dispatch(clearFilter(type));
  },
  showHotProducts: () => dispatch(showHots())
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsFilter);



// WEBPACK FOOTER //
// ./src/molecules/containers/ProductsFilter.js